import { Directive, TemplateRef } from '@angular/core';

@Directive({
    selector: '[carouselItem]',
    standalone: false
})
export class CarouselItemDirective {

  constructor( public tpl : TemplateRef<any> ) {
  }

}
